<script lang="ts" setup>
import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';

// props
const props = withDefaults(
  defineProps<{
    modalState?: boolean;
  }>(),
  {
    modalState: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'canceled'): void;
  (e: 'confirm'): void;
}>();

//変数
const t = i18n.t;
</script>

<template>
  <Modal
    class="confirm-modal-container"
    :modal-size="'max-content'"
    :modal-width="500"
    :aspect-ratio="true"
    :stretch-container="true"
    :scroll-off="true"
    :padding="'16px'"
    :modal-state="modalState"
    :border-radius="'16px'"
  >
    <div class="delete-order-content">
      <img class="delete-order-content__icon" src="@/assets/img/error_outline.png" />
      <span class="delete-order-content__title">
        {{ t('選択した発注を削除しますか？') }}
      </span>
      <span class="delete-order-content__description">
        {{ t('削除した発注の復元はできません。') }}
      </span>

      <div class="delete-order-content__button-container button-container">
        <TextButton
          :button-style="'btn-secondary-error'"
          :size="'btn-md'"
          :on-click="() => emits('canceled')"
          class="button-container--cancel-button"
        >
          {{ t('キャンセル') }}
        </TextButton>
        <TextButton
          :button-style="'btn-error'"
          :size="'btn-md'"
          :on-click="() => emits('confirm')"
          class="button-container--confirm-button"
        >
          {{ t('削除') }}
        </TextButton>
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.delete-order-content {
  height: 100%;
  display: grid;
  grid-template-rows: repeat(5, fit-content(20%));
  justify-items: center;
  row-gap: 24px;

  &__title {
    font-size: 22px;
    font-weight: bold;
    line-height: 28px;
    color: $textDefault;
    padding: 0px 32px;
    text-align: center;
  }
  &__label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: $textDefault;
  }
}

.header {
  display: grid;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  justify-items: center;
  gap: 16px;
  &__title {
    font-size: 22px;
    font-weight: bold;
    line-height: 28px;
  }
  &__description {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }
}

.button-container {
  display: grid;
  grid-template-columns: repeat(2, fit-content(50%));
  justify-self: center;
  gap: 16px;
  &--cancel-button {
    padding: 12px 32px 12px 32px;
  }
  &--confirm-button {
    padding: 12px 56px 12px 56px;
  }
}
</style>
